<app-upsell-card
  htmlTitle="<strong>SPF50 External Lotion Sunscreen</strong>"
  question="We strongly recommend including a strong sunscreen to your order. Would you like to add it to your treatment plan?"
  [slug]="slug"
>
  <p class="mb-4">Complete your routine with SPF 50 External Lotion Sunscreen.</p>
  <p class="mb-4">
    Prescription acne treatments make your skin more sensitive to the sun. Daily sunscreen is essential for protecting
    your results and preventing irritation and dark marks.
  </p>
  <p class="mb-3"><b>SPF 50 External Lotion = daily protection that supports clear skin</b></p>
  <p class="mb-3">
    <b>AM: shield + prevent</b><br />
    Protects acne-prone skin from UV damage that can worsen redness, inflammation, and post-acne dark spots. Helps
    prevent treatment-related sun sensitivity from your prescriptions.
  </p>
  <p class="mb-4">
    <b>All day: reapply during extended sun exposure</b><br />
    Continue to reapply every few hours while outside to ensure no loss in coverage.
  </p>
  <p class="mb-1"><b>Why add it?</b></p>
  <ul class="mb-4">
    <li>Prevents dark spots and uneven skin tone after breakouts.</li>
    <li>Reduces irritation caused by prescription acne treatments.</li>
    <li>Helps maintain clearer skin long-term.</li>
    <li>Broad-spectrum SPF 50 protection without a greasy feel.</li>
  </ul>
</app-upsell-card>
